import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const ContactOwners: React.FC = () => {
  const content = (
    <>
      <h2>Sådan kontakter du værktøjsejere</h2>
      <p>
        God kommunikation er nøglen til succesfuld værktøjsleje. Her er hvordan du kontakter ejere effektivt.
      </p>

      <h3>Hvornår skal du kontakte en ejer?</h3>
      <p>
        Du bør sende en besked når:
      </p>
      <ul>
        <li>Du har spørgsmål om værktøjet</li>
        <li>Du vil booke værktøjet</li>
        <li>Du ønsker at aftale detaljer</li>
        <li>Du har brug for instruktioner</li>
        <li>Der er ændringer i dine planer</li>
        <li>Der opstår problemer</li>
      </ul>

      <h3>Før booking: Stil spørgsmål</h3>

      <h4>Gode spørgsmål at stille</h4>
      <ul>
        <li>"Er værktøjet ledigt på [dato]?"</li>
        <li>"Hvilke tilbehør følger med?"</li>
        <li>"Er der noget jeg skal vide om brugen?"</li>
        <li>"Hvor kan jeg hente det?"</li>
        <li>"Hvordan foretrækker du betaling?"</li>
        <li>"Kræver du depositum?"</li>
      </ul>

      <h4>Information du bør dele</h4>
      <ul>
        <li>Hvad du skal bruge værktøjet til</li>
        <li>Din erfaring med lignende værktøj</li>
        <li>Ønskede datoer</li>
        <li>Eventuelle særlige behov</li>
      </ul>

      <h4>Eksempel besked før booking</h4>
      <blockquote>
        "Hej [Navn]! Jeg er interesseret i at leje din [værktøj] til [projekt]. 
        Jeg har brug for det fra [dato] til [dato]. Jeg har tidligere brugt [lignende værktøj], 
        men vil gerne have en kort instruktion. Er det ledigt i denne periode? 
        Mvh [Dit navn]"
      </blockquote>

      <h3>Når du sender en bookinganmodning</h3>

      <h4>Inkludér altid en besked</h4>
      <p>
        Selvom det er valgfrit, øger en besked dine chancer for godkendelse:
      </p>
      <ul>
        <li>Ejere er mere tilbøjelige til at acceptere når de ved hvem du er</li>
        <li>Det viser respekt og professionalisme</li>
        <li>Du kan stille spørgsmål med det samme</li>
        <li>Det starter en god dialog</li>
      </ul>

      <h4>Hvad skal beskeden indeholde?</h4>
      <ul>
        <li>Kort introduktion</li>
        <li>Hvad du skal bruge værktøjet til</li>
        <li>Din erfaring hvis relevant</li>
        <li>Eventuelle spørgsmål</li>
        <li>Venlig tone</li>
      </ul>

      <h4>Eksempel bookinganmodning besked</h4>
      <blockquote>
        "Hej [Navn], jeg vil gerne leje din [værktøj] til at [projekt]. 
        Det lyder perfekt til mit behov. Jeg er en erfaren gør-det-selv person 
        og vil behandle dit værktøj med respekt. Ser frem til at høre fra dig!"
      </blockquote>

      <h3>Efter booking er bekræftet</h3>

      <h4>Aftale detaljer</h4>
      <p>
        Brug chatfunktionen til at koordinere:
      </p>

      <h5>Afhentning</h5>
      <ul>
        <li>Præcist tidspunkt (ikke bare "lørdag")</li>
        <li>Nøjagtig adresse eller mødested</li>
        <li>Parkeringsmuligheder hvis relevant</li>
        <li>Ejerens telefonnummer for dagen</li>
      </ul>

      <h5>Betaling</h5>
      <ul>
        <li>Metode (MobilePay, bank, kontant)</li>
        <li>Tidspunkt (ved afhentning, etc.)</li>
        <li>Depositum størrelse</li>
        <li>Betalingsdetaljer (kontonummer, MobilePay nummer)</li>
      </ul>

      <h5>Returnering</h5>
      <ul>
        <li>Tidspunkt og sted</li>
        <li>Hvad skal rengøres/klargøres</li>
        <li>Hvordan depositum returneres</li>
      </ul>

      <h4>Eksempel koordineringsbesked</h4>
      <blockquote>
        "Super, tak for godkendelsen! Hvad tid passer det bedst for dig på lørdag? 
        Jeg er fleksibel mellem 9-16. Jeg betaler gerne via MobilePay hvis det passer dig. 
        Vi aftaler bare om det er OK at jeg returnerer det søndag aften omkring 18?"
      </blockquote>

      <h3>Kommunikationstips</h3>

      <h4>Vær venlig og professionel</h4>
      <ul>
        <li>Brug høflig tone</li>
        <li>Sig tak for svar</li>
        <li>Vær respektfuld for deres tid</li>
        <li>Undgå krav - stil spørgsmål</li>
      </ul>

      <h4>Vær klar og specifik</h4>
      <ul>
        <li>Undgå vage tidspunkter</li>
        <li>Giv alle nødvendige detaljer</li>
        <li>Svar på deres spørgsmål fyldestgørende</li>
        <li>Bekræft vigtige aftaler skriftligt</li>
      </ul>

      <h4>Svar hurtigt</h4>
      <ul>
        <li>Replies inden 24 timer</li>
        <li>Hurtigere hvis booking er tæt på</li>
        <li>Lad ejeren vide hvis du har brug for tid til at tænke</li>
      </ul>

      <h4>Vær ærlig</h4>
      <ul>
        <li>Om din erfaring (eller mangel på samme)</li>
        <li>Om hvad du skal bruge det til</li>
        <li>Hvis dine planer ændrer sig</li>
        <li>Ved problemer eller bekymringer</li>
      </ul>

      <h3>Efter booking begynder</h3>

      <h4>På afhentningsdagen</h4>
      <ul>
        <li>Bekræft at du er på vej hvis aftalt</li>
        <li>Informér hvis du er forsinket</li>
        <li>Send besked når du ankommer</li>
      </ul>

      <h4>Under lejeperioden</h4>
      <ul>
        <li>Kontakt ved problemer eller spørgsmål</li>
        <li>Informér om eventuelle skader med det samme</li>
        <li>Spørg om forlængelse hvis nødvendigt</li>
      </ul>

      <h4>Ved returnering</h4>
      <ul>
        <li>Bekræft at du kommer til tiden</li>
        <li>Informér hvis du er forsinket</li>
        <li>Tak ejeren for godt samarbejde</li>
      </ul>

      <h3>Hvis ejeren ikke svarer</h3>

      <h4>Før booking</h4>
      <ul>
        <li>Vent 24-48 timer</li>
        <li>Send en venlig opfølgning</li>
        <li>Hvis stadig intet svar, find et andet værktøj</li>
      </ul>

      <h4>Efter booking bekræftet</h4>
      <ul>
        <li>Prøv at ringe hvis du har nummeret</li>
        <li>Send påmindelse via DoMore</li>
        <li>Hvis tæt på afhentning: foreslå afbestilling</li>
        <li>Kontakt DoMore support hvis total radiostilhed</li>
      </ul>

      <h3>Hvis der opstår problemer</h3>

      <h4>Hold komunikationen i DoMore</h4>
      <p>
        <strong>Vigtigt:</strong> Kommunikér altid gennem DoMore platformen, ikke kun SMS/email.
      </p>
      <p>
        Hvorfor?
      </p>
      <ul>
        <li>Officiel dokumentation</li>
        <li>DoMore support kan se historikken</li>
        <li>Beskyttelse for begge parter</li>
        <li>Nemmere at løse tvister</li>
      </ul>

      <h4>Ved uenigheder</h4>
      <ul>
        <li>Forklar dit synspunkt roligt</li>
        <li>Lyt til deres perspektiv</li>
        <li>Henvism til jeres tidligere beskeder</li>
        <li>Foreslå kompromis</li>
        <li>Inddrag DoMore support hvis nødvendigt</li>
      </ul>

      <h3>Hvad skal du IKKE gøre</h3>

      <h4>Undgå disse fejl</h4>
      <ul>
        <li>❌ Sende mange beskeder i træk uden at vente på svar</li>
        <li>❌ Være uhøflig eller krævende</li>
        <li>❌ Forhandle aggressivt om pris</li>
        <li>❌ Lyve om din erfaring eller intentioner</li>
        <li>❌ Ignorere ejerens instruktioner eller regler</li>
        <li>❌ Kontakte uden for normale timer (før 8, efter 21)</li>
        <li>❌ Dele personlig information for tidligt</li>
      </ul>

      <h3>Særlige situationer</h3>

      <h4>Hvis du skal afbestille</h4>
      <blockquote>
        "Hej [Navn], jeg beklager meget, men jeg er desværre nødt til at afbestille 
        min booking pga. [grund]. Jeg ved det er ubelejligt og beklager virkelig. 
        Måske kan jeg booke en anden gang?"
      </blockquote>

      <h4>Hvis du ønsker at forlænge</h4>
      <blockquote>
        "Hej [Navn], jeg håber min leje går godt! Jeg har brug for [værktøj] 
        lidt længere end planlagt. Er det muligt at forlænge til [ny dato]? 
        Jeg betaler selvfølgelig for de ekstra dage."
      </blockquote>

      <h4>Hvis værktøj går i stykker</h4>
      <blockquote>
        "Hej [Navn], jeg er meget ked af det, men [værktøj] er desværre gået i stykker. 
        [Hvad skete]. Jeg har taget billeder som jeg sender nu. Jeg tager selvfølgelig 
        ansvar. Hvad vil du have jeg skal gøre?"
      </blockquote>

      <h4>Hvis du har spørgsmål under brug</h4>
      <blockquote>
        "Hej [Navn], hurtig spørgsmål om [værktøj]: [spørgsmål]? 
        Vil gerne sikre jeg bruger det korrekt. Tak!"
      </blockquote>

      <h3>Efter lejen: Feedback</h3>

      <h4>Efterlad en anmeldelse</h4>
      <ul>
        <li>Vær ærlig men konstruktiv</li>
        <li>Beskriv både det gode og eventuelle udfordringer</li>
        <li>Hjælp andre lejere</li>
        <li>Roser god service</li>
      </ul>

      <h4>Send en tak-besked</h4>
      <blockquote>
        "Tak for lån af [værktøj]! Det fungerede perfekt til mit projekt. 
        Det var nemt at samarbejde med dig. Jeg har efterladt en anmeldelse. 
        Måske vi kan handles igen en anden gang!"
      </blockquote>

      <h3>Opbygning af troværdighed</h3>

      <h4>Som ny bruger</h4>
      <p>
        Hvis du ingen ratings har endnu:
      </p>
      <ul>
        <li>Vær ekstra venlig og professionel</li>
        <li>Tilbyd at vise ID ved afhentning</li>
        <li>Vær villig til at betale depositum</li>
        <li>Giv referencer hvis muligt</li>
        <li>Start med mindre, billigere værktøj</li>
      </ul>

      <h4>Byg din rating</h4>
      <ul>
        <li>Vær pålidelig - mød til tiden</li>
        <li>Kommunikér godt</li>
        <li>Behandl værktøj med respekt</li>
        <li>Vær ærlig og transparent</li>
        <li>Efterlad anmeldelser til ejere</li>
      </ul>

      <h3>Kulturelle råd</h3>

      <h4>Danske normer</h4>
      <ul>
        <li>Punktlighed er vigtig</li>
        <li>Direkte men høflig kommunikation foretrækkes</li>
        <li>"Du" er standard, ikke "De"</li>
        <li>Informalitet er OK, men vær stadig respektfuld</li>
      </ul>

      <h4>Tillid og respekt</h4>
      <ul>
        <li>Danskere værdsætter ærlighed</li>
        <li>Hold hvad du lover</li>
        <li>Respektér andres tid og ejendele</li>
        <li>Vær ligeværdig - ikke underdanig eller arrogant</li>
      </ul>

      <h3>DoMore chat funktioner</h3>

      <h4>Sådan fungerer det</h4>
      <ul>
        <li>Find "Beskeder" i din profil</li>
        <li>Hver booking har sin egen chat-tråd</li>
        <li>Du får notifikationer ved nye beskeder</li>
        <li>Historik gemmes for fremtidig reference</li>
      </ul>

      <h4>Hvad du kan dele</h4>
      <ul>
        <li>✅ Tekstbeskeder</li>
        <li>✅ Billeder</li>
        <li>✅ Booking detaljer</li>
        <li>⚠️ Vær forsigtig med personlige oplysninger</li>
      </ul>

      <h3>Privatliv og sikkerhed</h3>

      <h4>Hvad du skal dele</h4>
      <ul>
        <li>Dit fornavn</li>
        <li>Generel lokation (ikke præcis adresse før booking bekræftet)</li>
        <li>Hvad du skal bruge værktøjet til</li>
        <li>Relevant erfaring</li>
      </ul>

      <h4>Hvad du skal vente med</h4>
      <ul>
        <li>Fuldt navn (til afhent ing)</li>
        <li>Telefonnummer (til afhentningsdag)</li>
        <li>Præcis adresse (når booking er bekræftet)</li>
        <li>Betalingsoplysninger (når detaljer aftales)</li>
      </ul>

      <h4>Hvad du ALDRIG skal dele</h4>
      <ul>
        <li>CPR-nummer</li>
        <li>Adgangskoder</li>
        <li>Banklogin</li>
        <li>Dankort detaljer</li>
      </ul>

      <h3>Sammenfatning</h3>
      <p>
        God kommunikation handler om:
      </p>
      <ul>
        <li>✅ At være venlig og respektfuld</li>
        <li>✅ At være klar og specifik</li>
        <li>✅ At svare hurtigt</li>
        <li>✅ At være ærlig</li>
        <li>✅ At dokumentere gennem DoMore</li>
        <li>✅ At opbygge tillid</li>
      </ul>
      <p>
        Med god kommunikation bliver hver leje en positiv oplevelse for begge parter!
      </p>
    </>
  );

  return (
    <HelpArticle
      title="Sådan kontakter du værktøjsejere"
      category="Populært"
      content={content}
      relatedArticles={[
        { title: 'Foretag din første booking', link: '/help/first-booking' },
        { title: 'Bookingprocessen forklaret', link: '/help/booking-process' },
      ]}
    />
  );
};

export default ContactOwners;
